import React, { useState } from 'react';
import styles from './ShareLinkCard.module.scss';
import Card from '../../../common/card/Card';
import { Button, TextField, Snackbar, Alert, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { SendOutlined } from '@mui/icons-material';
import { sendShareLink } from '../../../services/shareLinkService';
import QRCode from 'react-qr-code';

const ShareLinkCard = () => {
    const [link, setLink] = useState('');
    const [loading, setLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
    const [modalOpen, setModalOpen] = useState(false);
    const [deepLink, setDeepLink] = useState('');

    const handleTextChange = (e) => {
        setLink(e.target.value);
    };

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const response = await sendShareLink(link);
            if (response.data && response.data.deep_link) {
                setDeepLink(response.data.deep_link);
                setModalOpen(true);
                setLink('');
            } else {
                setSnackbar({ open: true, message: 'Link sent successfully!', severity: 'success' });
                setLink('');
            }
        } catch (error) {
            setSnackbar({ open: true, message: 'Failed to send link.', severity: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        setDeepLink('');
    };

    return (
        <div className={styles.container}>
            <Card title="Deeplink Test">
                <div className={styles.form}>
                    <TextField
                        name="link"
                        label="Share Link"
                        value={link}
                        placeholder="https://example.com/share"
                        required
                        variant="outlined"
                        fullWidth
                        onChange={handleTextChange}
                    />
                    <Button
                        variant="contained"
                        color="success"
                        disabled={!link || loading}
                        startIcon={<SendOutlined />}
                        onClick={handleSubmit}
                    >
                        {loading ? 'Sending...' : 'Send Link'}
                    </Button>
                </div>
            </Card>
            <Dialog open={modalOpen} onClose={handleCloseModal} maxWidth="sm" fullWidth>
                <DialogTitle className={styles.modalTitle}>
                    <div className={styles.titleContent}>
                        <span className={styles.titleIcon}>🔗</span>
                        Influio System Deeplink
                    </div>
                </DialogTitle>
                <DialogContent>
                    <div className={styles.qrContainer}>
                        <div className={styles.qrWrapper}>
                            <QRCode value={deepLink} size={256} />
                        </div>
                        <div className={styles.linkSection}>
                            <label className={styles.linkLabel}>Deep Link URL</label>
                            <TextField
                                value={deepLink}
                                variant="outlined"
                                fullWidth
                                multiline
                                rows={3}
                                InputProps={{
                                    readOnly: true,
                                }}
                                className={styles.linkTextField}
                            />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions className={styles.modalActions}>
                    <Button onClick={handleCloseModal} variant="contained" color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default ShareLinkCard;
